class KynLookbookGrid extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter]');
      if (!button || !this.contains(button)) return;
      this.applyFilter(button.dataset.filter);
    });
  }

  applyFilter(filter) {
    this.setAttribute('data-active-filter', filter);

    this.querySelectorAll('[data-filter]').forEach((button) => {
      const active = button.dataset.filter === filter;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    let visible = 0;
    this.querySelectorAll('.kyn-lookbook__frame').forEach((frame) => {
      const match = filter === 'All' || frame.dataset.kind === filter;
      frame.hidden = !match;
      if (match) visible += 1;
    });

    const countEl = this.querySelector('[data-frame-count]');
    if (countEl) {
      countEl.textContent = this.#countLabel(visible);
    }
  }

  /**
   * Picks the localized "n FRAMES" template for the language's plural category
   * (Polish needs one / few / many).
   * @param {number} count
   */
  #countLabel(count) {
    const category = new Intl.PluralRules(document.documentElement.lang || 'en').select(count);
    const templates = {
      one: this.dataset.framesOne,
      few: this.dataset.framesFew,
      many: this.dataset.framesMany,
      other: this.dataset.framesOther,
    };
    return (templates[category] ?? templates.other ?? '').replace('__COUNT__', String(count));
  }
}

if (!customElements.get('kyn-lookbook-grid')) {
  customElements.define('kyn-lookbook-grid', KynLookbookGrid);
}
